import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    .ant-tabs-nav-list {
      .ant-tabs-ink-bar {
        background: ${(props): string => props.theme.colors.black};
        height: 4px;
      }
    }

    .ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: ${(props): string => props.theme.colors.black};
        text-shadow: none;
      }
    }
  }

  .ant-tabs-content-holder {
    min-height: 100px;
  }

  .ant-tabs-tab-btn {
    :active {
      color: ${(props): string => props.theme.colors.black};
    }
  }
`;
